<template>
    <div class="backView">
        <div class="back"  :style="{top:showHeader?'50px':'0'}">
            <van-row class="back-row" justify="space-between" type="flex" >
                <van-col class="row-title ben-000-color" span="10"><strong>{{backTitle}}</strong></van-col>
                <van-col class="row-back-i" span="10" @click="historyGo">返回上一页<van-icon name="arrow" /></van-col>
            </van-row>
        </div>
    </div>
</template>
<script>
export default {
    name:'backView',
    props: {
        backTitle : String,
        showHeader : {
            type : Boolean,
            default : true
        }
    },
    data () {
        return {
            title : "报价列表"
        }
    },
    created () {
        
    },
    methods: {
        historyGo(){
            history.go(-1)
        }
    },
    mounted () {
        
    },
}

</script>


<style lang='scss' scoped>
.backView{
    height: 1.466667rem;
    width: 100%;
    z-index: 100;
    position: relative;
}
.back{
    position: fixed;
    top: 55px;
    height: 1.466667rem;
    width: 100%;
    height: 50px;
    border-top: 1px solid #EEEEEE;
    background: #EEEEEE;
    .back-row{
        height: 100%;
        padding: 0 14px;
        background: white;
        >div{
            line-height: 50px;
        }
        .row-back-i{
            text-align: right;
            color: #999;
            font-size: 14px;
        }
        .row-title{
            font-size: 15px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/view/procurement/components/backView.vue